var render = function render(){var _vm=this,_c=_vm._self._c;return _c('data-input-select',_vm._g(_vm._b({attrs:{"value":_vm.computedValue,"items":_vm.computedItems,"item-text":"text","item-value":"value"}},'data-input-select',{ ..._vm.$props, ..._vm.$attrs },false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }